import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { SignaturePadComponent } from '@almothafar/angular-signature-pad';

@Component({
  selector: 'app-conference-signature-question',
  templateUrl: './conference-signature-question.component.html',
  standalone: false
})
export class ConferenceSignatureQuestionComponent {
  @ViewChild(SignaturePadComponent) signaturePad: SignaturePadComponent;
  @Output() signatureChange = new EventEmitter<string>();

  signaturePadOptions: Record<string, number> = {
    minWidth: 1,
    canvasWidth: 600,
    canvasHeight: 180
  };
  captured = false;

  useSignature() {
    const data = this.signaturePad?.toDataURL?.() || '';
    if (!data || data === 'data:,') {
      return;
    }

    this.captured = true;
    this.signatureChange.emit(data);
  }

  clearSignature() {
    this.signaturePad?.clear();
    this.captured = false;
    this.signatureChange.emit('');
  }
}
